<div id="popup" class="coordinates-popup p-5">
  <div
    class="is-flex is-align-items-baseline is-justify-content-space-between pb-5"
  >
    <h4 class="p-0 m-0" translationEditableDirective="FIND_COORDINATES">
      {{ 'FIND_COORDINATES' | translate }}
    </h4>
    <button class="coordinates-close p-2" (click)="onClose.emit()">
      <img src="/assets/close-icon.svg" width="10px" />
    </button>
  </div>

  <radio
    name="searchMode"
    [value]="searchMode"
    [controlled]="true"
    [options]="searchModeOptions"
    (onChange)="setSearchMode($event)"
  ></radio>

  <ng-select
    *ngIf="searchMode !== 'coordinates'"
    [items]="searchResults"
    [typeahead]="onSearchAutocomplete$"
    [multiple]="false"
    [closeOnSelect]="true"
    [bindLabel]="searchMode"
    [loading]="isLoading"
    [placeholder]="(searchMode === 'propertyCode' ? 'SEARCH_PROPERTY_CODE' : 'SEARCH_BUILDING_CODE') | translate"
    [notFoundText]="'NO_RESULTS' | translate"
    (change)="onResultSelect($event)"
  >
    <ng-template ng-option-tmp let-item="item">
      {{ item[searchMode] }}
    </ng-template>
  </ng-select>

  <form
    *ngIf="searchMode === 'coordinates'"
    [formGroup]="coordinatesForm"
    (ngSubmit)="onCoordinatesSubmit()"
  >
    <div class="field">
      <label class="label" translationEditableDirective="LATITUDE">{{
        'LATITUDE' | translate
      }}</label>
      <div class="control">
        <number-input
          name="lat"
          formControlName="lat"
          [inputClass]="{ 'is-danger': coordinatesForm.get('lat').touched && coordinatesForm.get('lat').invalid, 'input is-small': true }"
        ></number-input>
      </div>
      <p
        class="help is-danger"
        *ngIf="coordinatesForm.get('lat').touched && coordinatesForm.get('lat').hasError('required')"
      >
        {{ 'REQUIRED' | translate }}
      </p>
      <p
        class="help is-danger"
        *ngIf="coordinatesForm.get('lat').touched && coordinatesForm.get('lat').hasError('invalidCoordinates')"
      >
        {{ 'INVALID_COORDINATES' | translate }}
      </p>
    </div>

    <div class="field">
      <label class="label" translationEditableDirective="LONGITUDE">{{
        'LONGITUDE' | translate
      }}</label>
      <div class="control">
        <number-input
          name="lng"
          formControlName="lng"
          [inputClass]="{ 'is-danger': coordinatesForm.get('lng').touched && coordinatesForm.get('lng').invalid, 'input is-small': true }"
        ></number-input>
      </div>
      <p
        class="help is-danger"
        *ngIf="coordinatesForm.get('lng').touched && coordinatesForm.get('lng').hasError('required')"
      >
        {{ 'REQUIRED' | translate }}
      </p>
      <p
        class="help is-danger"
        *ngIf="coordinatesForm.get('lng').touched && coordinatesForm.get('lng').hasError('invalidCoordinates')"
      >
        {{ 'INVALID_COORDINATES' | translate }}
      </p>
    </div>

    <button
      type="submit"
      class="button is-primary is-small"
      [disabled]="coordinatesForm.invalid"
      translationEditableDirective="FIND"
    >
      {{ 'FIND' | translate }}
    </button>
  </form>
</div>
